import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const LIST: AppRouteRecordRaw = {
  path: '/merchant', // 运营
  name: 'merchant',
  permission: 'merchant',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.merchant',
    requiresAuth: true,
    icon: 'icon-idcard',
    order: 1,
    permission: 'merchant',
  },
  children: [
    {
      path: 'merchantList', // The midline path complies with SEO specifications
      name: 'merchantList',
      permission: 'merchant:list',
      component: () => import('@/views/operation/merchantPerson/index.vue'),
      meta: {
        locale: 'menu.merchantList',
        requiresAuth: true,
        roles: ['*'],
        permission: 'merchant:list',
      },
    },
    // {
    //   path: 'merchantOrder', // The midline path complies with SEO specifications
    //   name: 'merchantOrder',
    //   permission: 'merchant:order',
    //   component: () => import('@/views/transaction/merchantOrder/index.vue'),
    //   meta: {
    //     locale: 'menu.merchantOrder',
    //     requiresAuth: true,
    //     roles: ['*'],
    //     permission: 'merchant:order',
    //   },
    // },
    {
      path: 'merchantTask', // The midline path complies with SEO specifications
      name: 'merchantTask',
      permission: 'merchant:task',
      component: () => import('@/views/operation/merchantTask/index.vue'),
      meta: {
        locale: 'menu.merchantTask',
        requiresAuth: true,
        roles: ['*'],
        permission: 'merchant:task',
      },
    },
  ],
};

export default LIST;
